import { FC } from 'react';

import { IconContainer } from '../IconContainer';
import { IconProps } from '../types';

export const ArrowCounterclockwiseClockStroke48: FC<IconProps> = ({
  size = 48,
  color = 'currentColor',
  className,
  style,
  svgClassName,
  svgStyle,
  ariaLabel,
  onClick,
}) => {
  return (
    <IconContainer
      size={size}
      className={className}
      style={style}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClassName}
        style={svgStyle}
      >
        <path d="M23.9971 9.33301C15.8972 9.33319 9.33106 15.9014 9.33106 24C9.33123 32.0984 15.8973 38.6658 23.9971 38.666L23.9971 36.3994C17.16 36.3992 11.5978 30.8371 11.5977 24C11.5977 17.1628 17.1599 11.5998 23.9971 11.5996C30.8344 11.5996 36.3975 17.1627 36.3975 24C36.3974 27.881 34.5993 31.341 31.7969 33.6123C31.1558 34.1318 30.2656 33.6347 30.2656 32.8096L30.2656 28.001L27.999 28.001L27.999 38.666L38.6641 38.666L38.6641 36.3994L34.1162 36.3994C33.4479 36.3991 33.1541 35.4607 33.6572 35.0205C36.7249 32.3366 38.664 28.3975 38.6641 24C38.6641 15.9013 32.0971 9.33301 23.9971 9.33301ZM21.5527 14.666L24.1094 24.3994L18.6641 24.3994L18.6641 26.666L23.585 26.666C25.3409 26.666 26.6166 25.0012 26.1621 23.3066L23.9014 14.666L21.5527 14.666Z" fill={color}/>
      </svg>
    </IconContainer>
  );
};
